import takeSnapShot from './util/takeSnapShot';
import {generateSection} from "./util/generateSection";

// Define a variable to store the timeout ID
let debounceTimeout;

const updateSections = ({
    inSectionData,
    product
}) => {
    return new Promise(async (resolve, reject) => {

        // Clear the previous timeout
        clearTimeout(debounceTimeout);

        const prevSection = window.threeViewer.scene.children.find(e => e.userData.id === inSectionData.sectionId);
        if (prevSection) {
            window.threeViewer.scene.remove(prevSection)
            prevSection.material.dispose()
            prevSection.geometry.dispose()
            prevSection.material?.map?.dispose()
        }
        const section = await generateSection(inSectionData, product);
        window.threeViewer.scene.add(section)

        section.update()
        // Set a new timeout for takeSnapShot
        let lDebounceTime = setTimeout(async () => {
            const PreviewImage = await takeSnapShot(inSectionData, false);
            const thumbnail_image_url = URL.createObjectURL(PreviewImage);
            inSectionData["thumbnail_image_url"] = thumbnail_image_url;
            resolve(true);
        }, 500)

        setTimeout(() => {
            if (lDebounceTime < debounceTimeout) {
                resolve(true);
            }
        }, 400)
        debounceTimeout = lDebounceTime;

    });
}

export default updateSections;